/*
Replace
counter with your resource Name :) Take care about different writings!
/!\ Counter counter Counters counters /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const counterSlice = createSlice({
  name: "counters",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
  },
});

export const {
  list: listCounters,
  show: showCounter,
  create: createCounter,
  update: updateCounter,
} = counterSlice.actions;

export const actions = counterSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const counters = (state) =>
  state.counters.idsList.map((id) => state.counters.dictionary[id]);
export const counter = (state) =>
  state.counters.showId && state.counters.dictionary[state.counters.showId];
export const counterAttributes = (state) => counter(state)?.attributes;
export const counterRelationships = (state) => counter(state)?.relationships;
export const counterId = (state) => state.counters.showId;

export const getCounter = createSelector(
  (state) => state.counters.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getCounterAttributes = createSelector(
  (state) => state.counters.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getCounterRelationships = createSelector(
  (state) => state.counters.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getCounters = createSelector(
  (state) => state.counters.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export const getFeedbackCounters = createSelector(
  (state) => state.counters.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return (
      ids &&
      dictionary &&
      ids
        .map((id) => dictionary[id])
        .filter((counter) => counter?.attributes?.display_in_feedback === true)
    );
  }
);

export default counterSlice.reducer;
